export default {
    hydrometeorological: {
        precipitacion: 'Precipitación (mm)',
        temperatura: 'Temperatura (°C)',
        humedad_relativa: 'Humedad Relativa (%)',
        velocidad_viento: 'Velocidad del viento (m/s)',
        direccion_viento: 'Dirección del viento (°)',
        presion_barometrica: 'Presión barométrica (mmHg)',
        radiacion_solar: 'Radiación solar (W/m<sup>2</sup>)',
        evapotranspiracion: 'Evapotranspiración (mm)'
    },
    hydrological: {
        nivel: 'Nivel (cm)',
        caudal: 'Caudal (L/S)'
    },
    groundWater:{
        raw_water_temperature: 'Temperatura del agua (°C)',
        groundwater_level: 'Nivel (cm)',
        hydrostatic_charge: 'Carga Hidrostática (m)'
    },

    airGasesVariables:{
        co_local_ppt: 'CO (mg/m<sub>3</sub>)',
        o3_local_ppt: 'O<sub>3</sub> (µg/m<sub>3</sub>)',
        so2_local_ppt: 'SO<sub>2</sub> (µg/m<sub>3</sub>)'
    },

    airParticulateMaterialVariables: {
        pm2_5: 'PM<sub>2.5</sub>',
        pm10: 'PM<sub>10</sub>',
        pst: 'PST(µg/m<sub>3</sub>)'
    }
}